"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactCapability = void 0;
var ContactCapability;
(function (ContactCapability) {
    ContactCapability["CONTACT_FOR_PROMOTE_TO_PRIMARY"] = "contact_for:promote_to_primary";
    ContactCapability["CONTACT_FOR_REMOVE_AS_PRIMARY"] = "contact_for:remove_as_primary";
    ContactCapability["CONTACT_FOR_REMOVE_AS_CONTACT"] = "contact_for:remove_as_contact";
})(ContactCapability || (exports.ContactCapability = ContactCapability = {}));
